import {effect, inject, Injectable} from '@angular/core';
import {RxStomp} from '@stomp/rx-stomp';
import {IMessage} from '@stomp/stompjs';
import {Observable, Subject} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, ReadyArgs, typeEventArgs} from 'keycloak-angular';
import Keycloak from "keycloak-js";
import {createSuiteBackendRxStompConfig} from './suite-backend-rx-stomp.config';

@Injectable({
  providedIn: 'root'
})
export class SuiteBackendRxStompService extends RxStomp {

  private destroy$ = new Subject<void>();
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

  constructor() {
    super();
    effect(() => {
      const keycloakEvent = this.keycloakSignal();

      if (keycloakEvent.type === KeycloakEventType.Ready && typeEventArgs<ReadyArgs>(keycloakEvent.args)) {
        this.keycloak.loadUserProfile().then(profile => {
          this.configure(createSuiteBackendRxStompConfig(profile.username, this.keycloak.token));
          this.activate();
        });
      }

      if (keycloakEvent.type === KeycloakEventType.TokenExpired) {
        this.refreshAndReconnect();
      }

      if (keycloakEvent.type === KeycloakEventType.AuthRefreshError) {
      }

      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
      }
    });

    this.handleErrors();
  }

  private handleErrors(): void {
    this.stompErrors$
      .pipe(
        tap((error) => console.error('SUITE-BACKEND STOMP error:', error)),
        takeUntil(this.destroy$)
      )
      .subscribe((error) => {
        this.refreshAndReconnect();
      });

    this.webSocketErrors$
      .pipe(
        tap((error) => console.error('SUITE-BACKEND WebSocket error:', error)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.refreshAndReconnect());
  }

  private async refreshAndReconnect(): Promise<void> {
    try {
      await this.keycloak.updateToken(-1);
      await this.deactivate();
      this.keycloak.loadUserProfile().then(profile => {
        this.configure(createSuiteBackendRxStompConfig(profile.username, this.keycloak.token));
        this.activate();
      });
    } catch (error) {
      console.error('Token refresh failed:', error);
      await this.deactivate();
    }
  }

  watchTopic(destination: string): Observable<IMessage> {
    return this.watch({destination}).pipe(
      takeUntil(this.destroy$)/*,
      tap((message) => console.log('Received message:', message.body))*/
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.deactivate();
  }

}
